var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#clip0_4037_1168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.56951 0L0.861816 2.69584L9.1783 10.9759L0.861816 19.3042L3.56951 22L11.886 13.6718L20.1541 21.9519L22.8618 19.256L14.5937 10.9759L22.8618 2.69584L20.1541 0.04814L11.886 8.32823L3.56951 0Z",
    fill: "#A994FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4037_1168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.861816)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.30859fd9aa8c2f03ec24fd3dc6513055.svg";
export { ForwardRef as ReactComponent };